import React from "react";
import PageShell from "@/components/layout/PageShell";
import SubHero from "@/components/layout/SubHero";

const sections = [
  ["Accounts and assessment access", "Use accurate account information, protect your password, and use your account for your own assessment and saved profile."],
  ["Saved results", "Your assessment responses and results can be saved to your APOS account so you can return to them and connect them with future Companion access."],
  ["Companion beta", "The APOS Companion remains in beta. Features, subscription access, payment options, and availability may change as the experience is tested and prepared for release."],
  ["Respectful use", "Do not attempt to disrupt the service, access another person’s information, or misuse assessment, account, Companion, or administrator features."],
];

const Terms = () => (
  <PageShell>
    <SubHero breadcrumb={[{ label: "Home", to: "/" }, { label: "Terms" }]} overline="Terms" headline="Using Adaptive Physiology" headlineAccent="and APOS." lead="These terms cover account access, saved assessment results, and APOS Companion beta participation." />
    <section className="py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-6 sm:px-10">
        <div className="grid gap-4">
          {sections.map(([title, body]) => (
            <article key={title} className="rounded-[22px] p-7 forr-surface" style={{ border: "1px solid var(--forr-line)" }}>
              <h2 className="font-display text-2xl forr-text-ink">{title}</h2>
              <p className="mt-3 text-sm leading-relaxed forr-text-soft">{body}</p>
            </article>
          ))}
        </div>
        <p className="mt-8 text-sm leading-relaxed forr-text-soft">Questions can be sent to <a href="mailto:forrhealth.0@gmail.com" className="font-semibold forr-text-teal-deep">forrhealth.0@gmail.com</a>.</p>
      </div>
    </section>
  </PageShell>
);

export default Terms;
